import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import actions from '@/store/actions'
import mutations from '@/store/mutations'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loading: false,
    showAddToHomeScreen: false,
    db: null,

    showLogin: false,
    appCredentials: null,

    userInfo: null,

    promptedToAddPwa: false,

    // stored files
    uploadQueue: [],
    processingQueue: false,

    notes: [],
    drafts: [],
    mynotes: [],
    nearbynotes: [],

    current_page: 1,
    total_pages: null,

    location: null,

    bannerStatus: {
      show: false,
      text: ''
    }
  },

  actions,
  mutations,

  getters: {
    loggedIn ({ appCredentials, userInfo }) {
      return !!appCredentials && !!userInfo
    }
  },

  plugins: [
    createPersistedState({
      reducer: state => ({
        appCredentials: state.appCredentials,
        userInfo: state.userInfo,
        promptedToAddPwa: state.promptedToAddPwa
      })
    })
  ]
})
